import { render, staticRenderFns } from "./PaprikaDiseaseAnalysis.vue?vue&type=template&id=1b90abc0&"
import script from "./PaprikaDiseaseAnalysis.vue?vue&type=script&lang=js&"
export * from "./PaprikaDiseaseAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports